export const NAME = "fetching";

export const MANIFEST_FETCHING_ID = "manifest-fetching-id";
